import * as THREE from 'three';

/**
 * Creates and returns the Three.js renderer, scene, and lights.
 * The renderer canvas is appended to document.body.
 */
export function createScene() {
  // ── Renderer ──────────────────────────────────────────────────────────────
  const renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type    = THREE.PCFSoftShadowMap;
  renderer.toneMapping       = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 0.85;
  renderer.outputColorSpace  = THREE.SRGBColorSpace;
  document.body.appendChild(renderer.domElement);

  // ── Scene ─────────────────────────────────────────────────────────────────
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0x87ceeb);
  scene.fog        = new THREE.FogExp2(0x9bc8d8, 0.0028);

  // ── Ambient light ─────────────────────────────────────────────────────────
  const ambient = new THREE.AmbientLight(0xfff8e7, 0.65);
  scene.add(ambient);

  // ── Directional sun ───────────────────────────────────────────────────────
  const sun = new THREE.DirectionalLight(0xfff3d0, 1.15);
  sun.position.set(250, 400, 180);
  sun.castShadow = true;

  const sc = sun.shadow.camera;
  sc.near   = 10;
  sc.far    = 1400;
  sc.left   = -700;
  sc.right  =  700;
  sc.top    =  700;
  sc.bottom = -700;

  sun.shadow.mapSize.width  = 4096;
  sun.shadow.mapSize.height = 4096;
  sun.shadow.bias           = -0.0005;
  sun.shadow.normalBias     = 0.02;

  scene.add(sun);
  scene.add(sun.target); // target is at origin; main.js will move it

  // ── Hemisphere sky-ground fill ────────────────────────────────────────────
  const hemi = new THREE.HemisphereLight(0x87ceeb, 0x4a7c59, 0.35);
  scene.add(hemi);

  return { scene, renderer, sun, ambient, hemi };
}
